import { ArtifactDownloader } from './ArtifactDownloader';
import { AsyncCommandPoller } from './AsyncCommandPoller';
import { AttachmentsHelper } from './attachments';
import {
  InvoiceLineHelper,
  InvoiceLineCalculator,
  CurrencyDigitsHelper,
} from './InvoiceLineHelper';

export const appHelpers = {
  ArtifactDownloader,
  AsyncCommandPoller,
  AttachmentsHelper,
  InvoiceLineCalculator,
  InvoiceLineHelper,
  CurrencyDigitsHelper,
};
